import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { NoMatch } from './Scenes/NoMatch';
import Config from './Config';

const RouteWithSubRoutes = (route, ...rest) => (
  <route.route
    exact={route.exact}
    path={route.path}
    redirectTo={route.redirectTo}
    component={route.component}
    {...rest}
  />
);
// eslint-disable-next-line no-unused-vars
const Routes = ({ system, theme, ...rest }) => {
  const { routes } = system;
  const { current } = theme;
  return (
    <div className={current}>
      <Router basename={Config.baseNameUrl}>
        <Switch>
          {/* eslint-disable-next-line no-unused-vars */}
          {routes.map((route, i) => (
            <RouteWithSubRoutes key={route.path} {...route} className={current} />
          ))}
          <Route component={NoMatch} />
        </Switch>
      </Router>
    </div>
  );
};

Routes.propTypes = {
  system: PropTypes.shape({
    routes: PropTypes.arrayOf(PropTypes.any),
  }),
  theme: PropTypes.shape({
    current: PropTypes.string,
    // eslint-disable-next-line react/forbid-prop-types
    logo: PropTypes.any,
  }).isRequired,
};

Routes.defaultProps = {
  system: {
    routes: [],
  },
};

const mapStateToProps = state => {
  const system = state.get('system').toJS();
  const auth = state.get('auth').toJS();
  const theme = state.get('theme').toJS();

  return {
    auth,
    system,
    theme,
  };
};

export default connect(mapStateToProps)(Routes);
